module.exports = __webpack_public_path__ + "static/media/henrydevsquare.a974daf2.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/images/henrydevsquare.gif
// module id = 135
// module chunks = 0